import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-ltl-popover-footer',
  host: { class: 'xpo-ltl-Popover-footer' },
})
export class XpoLtlPopoverFooter {}
